import TYPES from '@/modules/shared/types';

// Domain
import { SettlementRepository } from '../../domain/repository';
import { SettlementEntity } from '../../domain/entities/settlement-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class SettlementHttpRepository implements SettlementRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/settlements/search?codigoPostal={CODIGO_POSTAL}`;

  execute(codigo_postal: string): Promise<Array<SettlementEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{CODIGO_POSTAL}', codigo_postal))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
